import React from 'react';
import {Dialog,} from '@material-ui/core';
//import makeStyles from "@material-ui/core/styles/makeStyles";


// const useStyles = makeStyles((theme) => ({
//     test: {
//
//     },
// }))
const  PointsPopupsDialog = ({themeMaterialUI, handleClose, punkt }) => {

    console.log('punkt', punkt)
    return(
        <Dialog
            open={true}
            onClose={handleClose}
         //   className={cl.test}
        >
            <p>test</p>
        </Dialog>

    )
}

export default PointsPopupsDialog